
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import enLocal from '../../../core/locals/english.locale.json';
import { set_locale } from '../actions';

export default createReducer({
	[set_locale]: 
		(state, { locale, language }) => update(state, { current: { $set: locale }, language: { $set: language } }),
}, {
	current: enLocal,
	language: { id: 1, name: 'English', short: 'en-gb', flag: 'gb' },
	available: [
		{ id: 1, name: 'English', short: 'en-gb', flag: 'gb' },
		{ id: 2, name: 'Hebrew', short: 'he', flag: 'il' },
		{ id: 5, name: 'Arabic', short: 'ar-ar', flag: 'ar' },

	]
});
